import {
  GET_BOOKING_REQUESTED,
  GET_CUSTOMER_MATRIX_REQUESTED,
  GET_REVENUE_EXPORT_REQUESTED,
  GET_REVENUE_MATRIX_REQUESTED,
  GET_REVENUE_REQUESTED,
} from "resources/actionTypes";

export function getBooking(data) {
  return {
    type: GET_BOOKING_REQUESTED,
    payload: data,
  };
}

export function getRevenue(data) {
  return {
    type: GET_REVENUE_REQUESTED,
    payload: data,
  };
}

export function getRevenueMatrix(data) {
  return {
    type: GET_REVENUE_MATRIX_REQUESTED,
    payload: data,
  };
}

export function getRevenueExport(data) {
  return {
    type: GET_REVENUE_EXPORT_REQUESTED,
    payload: data,
  };
}

export function getCustomerMatrix(data) {
  return {
    type: GET_CUSTOMER_MATRIX_REQUESTED,
    payload: data,
  };
}
